module.exports = __webpack_public_path__ + "assets/451c973d5e7810cc2617900461d8c070.png";